module.exports = __webpack_public_path__ + "img/404.d884eb56.png";